const LoadingSpinner = ({className}: {className?: string}) => {
  return (
    <div
      className={`border-4 border-t-4 border-t-primary border-gray-400 rounded-full w-6 h-6 animate-spin ${className}`}></div>
  );
};

export default LoadingSpinner;
